// China
export const locale = {
  lang: 'zh',
  data: {
    TRANSLATOR: {
      SELECT: '选择你的语言',
    },
    SIDEBAR: {
      RIDES_CONFIG: 'Rides',
      RIDES_CONFIG_SETTINGS: 'Settings',
      RIDES_CONFIG_GUEST_PHONES: 'Guest phones',
      RIDES_CONFIG_PROVIDERS: 'Providers',
      FACE_VERIFICATION_CONFIG: 'Face verification',
    },
    PAGES: {
      CORPORATION_OFFICE_DETAIL: {
        TITLE: '办公室详情',
        BACK_BUTTON: '返回',
        TAB_OVERVIEW: '常规信息',
        TAB_USERS: '已分配用户',
        GENERAL_INFORMATION: '常规信息',
        ADDITIONAL_INFORMATION: '附加信息',
        CONTACT_PERSON: '联系人',
        CONTACT_PHONE: '联系电话',
        CONTACT_EMAIL: '联系邮箱',
        STATUS: '状态',
        COMMERCIAL_ADDRESS: '商业地址',
        CITY: '城市',
        POSTAL_CODE: '邮政编码',
        LOADING: '正在加载办公室信息...',
        LOADING_USERS: '正在加载用户...',
        ERROR: '错误',
        USERS: '用户',
        USER_NAME: '名称',
        USER_EMAIL: '邮箱',
        USER_PHONE: '电话',
        USER_CORPORATE_EMAIL: '公司邮箱',
        USER_PERSONAL_EMAIL: '个人邮箱',
        USER_DNI: 'DNI',
        USER_DEPARTMENT: '部门',
        USER_CORPORATE_PHONE: '公司电话',
        USER_CONFIRMED: '已确认',
        USER_ROLE: '角色',
        OFFICE_CODE: '办公室代码',
        CORPORATION: '公司',
        CREATED_AT: '创建:',
        UPDATED_AT: '更新:',
        NO_USERS: '该办公室没有用户',
        WAIIS_LINK: '在WAIIS中查看',
        DELETE_USER: '删除',
        DELETE_CONFIRMATION: '确定要删除此用户吗?',
        DELETE_CONFIRM_BUTTON: '是的,删除',
        DELETE_CANCEL_BUTTON: '取消',
        ACTIONS: '操作',
        EDIT_USER: '编辑用户',
        ADD_USER: '添加用户',
        REQUIRED_FIELDS: '必填字段',
        OPTIONAL_FIELDS: '可选字段(至少需要一个)',
        NAME: '名称',
        SURNAME: '姓氏',
        DEPARTMENT: '部门',
        CORPORATE_EMAIL: '公司邮箱',
        PERSONAL_EMAIL: '个人邮箱',
        DNI: 'DNI',
        CORPORATE_PHONE: '公司电话',
        PERSONAL_PHONE: '个人电话',
        CONFIRMED: '已确认',
        STATUS_PENDING: '待定',
        STATUS_REJECTED: '已拒绝',
        STATUS_ACCEPTED: '已接受',
        STATUS_ACTIVE: '活跃',
        STATUS_INACTIVE: '非活跃',
        CANCEL: '取消',
        SAVE_USER: '保存用户',
        UPDATE_USER: '更新用户',
        WAIT: '等待',
        UPLOAD_CSV: '上传CSV',
        UPLOADING: '上传中...',
        LINK_USERS: '链接用户',
        LINKING: '正在链接...',
        ERROR_REQUIRED_FIELD: '必填字段',
        ERROR_INVALID_EMAIL: '邮箱无效',
        ERROR_MIN_LENGTH: '必须至少为2个字符',
        ERROR_INVALID_FIELD: '字段无效',
      },
    },
    MENU: {
      NEW: '新',
      ACTIONS: '行动',
      CREATE_POST: '创建新帖子',
      PAGES: 'Pages',
      FEATURES: '特征',
      APPS: '应用',
      DASHBOARD: '仪表板',
    },
    AUTH: {
      GENERAL: {
        OR: '要么',
        SUBMIT_BUTTON: '提交',
        NO_ACCOUNT: '没有账号？',
        SIGNUP_BUTTON: '注册',
        FORGOT_BUTTON: '忘记密码',
        BACK_BUTTON: '背部',
        PRIVACY: '隐私',
        LEGAL: '法律',
        CONTACT: '联系',
      },
      LOGIN: {
        TITLE: '创建帐号',
        BUTTON: '签到',
      },
      FORGOT: {
        TITLE: 'Forgotten Password?',
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        TITLE: 'Sign Up',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfuly registered.',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: '用戶名',
      },
      VALIDATION: {
        INVALID: '{{name}} is not valid',
        REQUIRED: '{{name}} is required',
        MIN_LENGTH: '{{name}} minimum length is {{min}}',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested {{name}} is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
      },
    },
    HTTP_ERRORS: {
      FORBIDDEN: {
        TITLE: '拒绝访问',
        MESSAGE: '您无权访问此资源。',
        CONFIRM: '知道了',
      },
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Selected records count: ',
        ALL: 'All',
        SUSPENDED: 'Suspended',
        ACTIVE: 'Active',
        FILTER: 'Filter',
        BY_STATUS: 'by Status',
        BY_TYPE: 'by Type',
        BUSINESS: 'Business',
        INDIVIDUAL: 'Individual',
        SEARCH: 'Search',
        IN_ALL_FIELDS: 'in all fields',
      },
      ECOMMERCE: 'eCommerce',
      CUSTOMERS: {
        CUSTOMERS: '顾客',
        CUSTOMERS_LIST: '客户名单',
        NEW_CUSTOMER: 'New Customer',
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: 'Customer Delete',
          DESCRIPTION: 'Are you sure to permanently delete this customer?',
          WAIT_DESCRIPTION: 'Customer is deleting...',
          MESSAGE: 'Customer has been deleted',
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: 'Customers Delete',
          DESCRIPTION: 'Are you sure to permanently delete selected customers?',
          WAIT_DESCRIPTION: 'Customers are deleting...',
          MESSAGE: 'Selected customers have been deleted',
        },
        UPDATE_STATUS: {
          TITLE: 'Status has been updated for selected customers',
          MESSAGE: 'Selected customers status have successfully been updated',
        },
        EDIT: {
          UPDATE_MESSAGE: 'Customer has been updated',
          ADD_MESSAGE: 'Customer has been created',
        },
      },
    },
    WAIIS: {
      FACE_VERIFICATION: {
        SETTINGS: {
          TITLE: 'Face verification',
          GENERAL_TITLE: 'General switch',
          KILL_SWITCH_WARNING: 'Emergency kill switch: when turned off, nobody is required to pass face verification.',
          ENABLED_LABEL: 'Face verification enabled',
          THRESHOLDS_TITLE: 'Rekognition thresholds',
          LIVENESS_THRESHOLD_LABEL: 'Liveness confidence threshold',
          LIVENESS_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          SIMILARITY_THRESHOLD_LABEL: 'Similarity threshold',
          SIMILARITY_THRESHOLD_HINT: 'Number between 0 and 100 (decimals allowed)',
          REFERENCE_TITLE: 'Comparison reference',
          REFERENCE_TECALIS_LABEL: 'Tecalis selfie',
          REFERENCE_TECALIS_HINT: 'Always against the selfie Tecalis verified against the ID document',
          REFERENCE_ENROLLMENT_LABEL: 'Capture after near misses',
          REFERENCE_ENROLLMENT_HINT: 'First against the Tecalis selfie; after several near misses the liveness image is stored and later checks compare against it',
          ENROLLMENT_MIN_SIMILARITY_LABEL: 'Minimum similarity of a near miss',
          ENROLLMENT_MIN_SIMILARITY_HINT: 'Number between 0 and 100 (decimals allowed). A Tecalis selfie with no detectable face also counts',
          ENROLLMENT_ATTEMPTS_LABEL: 'Near misses to store the capture',
          ENROLLMENT_ATTEMPTS_HINT: 'Whole number between 1 and 10, counting all the user\'s trips',
          UPDATED_AT_LABEL: 'Last modified',
          DISABLE_CONFIRM_TITLE: 'Turn off face verification?',
          DISABLE_CONFIRM_TEXT: 'Nobody will be required to pass face verification until it is turned back on.',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Settings could not be loaded',
          ERROR_SAVE: 'Changes could not be saved',
          ERROR_FORBIDDEN: 'You do not have permission to perform this action',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            INTEGER: 'The value must be an integer',
            RANGE: 'The value must be between 0 and 100',
            ATTEMPTS_RANGE: 'The value must be between 1 and 10',
          },
        },
      },
      RIDES_CONFIG: {
        SETTINGS: {
          TITLE: 'Ride settings',
          VTC_LABEL: 'VTC enabled',
          VTC_HINT: 'Controls global availability of VTC rides in the app',
          VTC_CONFIRM_TITLE: 'Are you sure?',
          VTC_DISABLE_TEXT: 'Disabling VTC will hide the request-ride button in the app for all users',
          VTC_ENABLE_TEXT: 'Enabling VTC will show the request-ride button in the app again',
          VTC_SAVED: 'VTC updated',
          CONFIRM: 'Confirm',
          CANCEL: 'Cancel',
          RIDE_PRODUCTS_ENABLED_LABEL: 'WAIIS products in estimates',
          RIDE_PRODUCTS_ENABLED_HINT: 'On: the WAIIS products are shown and, for each one, the cheapest provider. Off: the real product list of each visible provider is shown (e.g. for certifications).',
          COMMISSION_ENABLED_LABEL: 'Charge commission',
          COMMISSION_PERCENT_LABEL: 'Commission %',
          COMMISSION_PERCENT_HINT: 'Percentage between 0 and 100 (two decimals)',
          CANCELLATION_PENALTY_LABEL: 'Cancellation penalty %',
          CANCELLATION_PENALTY_HINT: 'Percentage between 0 and 100',
          REAL_FEE_ADJUSTMENT_LABEL: 'Real fee adjustment',
          REAL_FEE_ADJUSTMENT_HINT: 'Recalculate the penalty using the provider\'s real fee',
          REAL_FEE_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          RECEIPT_ADJUSTMENT_LABEL: 'Receipt adjustment on completed rides',
          RECEIPT_ADJUSTMENT_HINT: 'Reconcile the difference against the amount charged when the provider receipt arrives',
          RECEIPT_ADJUSTMENT_ENABLED_AT_LABEL: 'Applies to rides created from',
          ADJUSTMENT_NEVER_ENABLED: 'Never enabled',
          SAVE: 'Save',
          SAVING: 'Saving...',
          SAVED: 'Settings saved',
          ERROR_TITLE: 'Error',
          ERROR_LOAD: 'Could not load settings',
          ERROR_SAVE: 'Could not save changes',
          ACCEPT: 'Accept',
          VALIDATION: {
            REQUIRED: 'This field is required',
            RANGE: 'Value must be between 0 and 100',
          },
        },
        GUEST_PHONES: {
          TITLE: 'Guest phones',
          EMPTY: 'No phones configured',
          TABLE: {
            PHONE_NUMBER: 'Phone number',
            ACTIVE: 'Active',
            ACTIONS: 'Actions',
          },
          ACTIONS: {
            ADD: 'Add',
            EDIT: 'Edit',
            DELETE: 'Delete',
            CANCEL: 'Cancel',
            SAVE: 'Save',
            ACCEPT: 'Accept',
          },
          MODAL: {
            CREATE_TITLE: 'New guest phone',
            EDIT_TITLE: 'Edit guest phone',
          },
          FORM: {
            PHONE_NUMBER: 'Phone number',
            PHONE_PLACEHOLDER: '+34600000000',
            PHONE_HINT: 'E.164 format: international prefix with + (e.g. +34600000000)',
          },
          VALIDATION: {
            PHONE_REQUIRED: 'Phone number is required',
            PHONE_FORMAT: 'Invalid format: use E.164 (+ and 7–15 digits)',
          },
          DELETE: {
            TITLE: 'Delete phone?',
            TEXT: '{{phone}} will be removed from the guest pool',
            CONFIRM: 'Yes, delete',
          },
          ERROR: {
            TITLE: 'Error',
          },
        },
        PROVIDERS: {
          TITLE: 'Providers and product mapping',
          RIDE_PRODUCTS: {
            TITLE: 'WAIIS products',
            HELP: 'These are the products the rider sees. Each provider maps one of its real products to every WAIIS product; the estimate shows the cheapest mapped provider.',
            ADD: 'Add WAIIS product',
            MOVE_UP: 'Move up',
            MOVE_DOWN: 'Move down',
            TABLE: {
              ORDER: 'Order',
              PRODUCT: 'Product',
              VISIBLE: 'Visible',
              ACTIONS: 'Actions',
            },
            MODAL: {
              NEW_TITLE: 'New WAIIS product',
              EDIT_TITLE: 'Edit WAIIS product',
              KEY: 'Key',
              KEY_HELP: 'Internal identifier in lowercase, digits and hyphens (e.g. go, premium-xl). It cannot be changed later.',
              DISPLAY_NAME: 'Name',
              IMAGE: 'Image',
              IMAGE_HELP: 'URL of the icon the rider sees',
              DESCRIPTION: 'Description',
              DESCRIPTION_HELP: 'Optional, per language. Only languages with text are stored.',
              VISIBLE: 'Visible',
            },
            VALIDATION: {
              KEY_REQUIRED: 'The key is required',
              KEY_FORMAT: 'Only lowercase letters, digits and hyphens (50 characters max)',
              DISPLAY_NAME_REQUIRED: 'The name is required',
            },
            CONFIRM: {
              DELETE_TITLE: 'Delete WAIIS product?',
              DELETE_TEXT: '"{{product}}" will be permanently deleted',
            },
            ERROR: {
              IN_USE: 'It cannot be deleted: there are still mappings pointing to it in {{providers}}',
            },
          },
          ROUTE: {
            TITLE: 'Sample route for product discovery',
            HELP: 'Providers only reveal their products when estimating a trip, and the catalog changes by city. Pick an origin and destination in the city you want to query: the route is saved for the whole team.',
            PICKUP: 'Origin',
            DROPOFF: 'Destination',
          },
          DISCOVER: {
            BUTTON: 'Discover provider products',
            ADD_TAG: 'Use this key: ',
            PLACEHOLDER: 'Type the key or discover the provider products',
            EMPTY: 'No products discovered yet',
            CAPACITY: '{{capacity}} seats',
            MAPPED_TO: 'Already mapped to {{product}}',
            MAPPED_HIDDEN: 'Mapped and hidden',
            REFRESH: 'Query the provider again',
            ROUTE_USED: 'Sample route: {{pickup}} → {{dropoff}}',
            NO_ROUTE: 'Set the sample route on the providers page to discover products',
            ERROR: {
              DISABLED: 'The provider is disabled on the server',
              UNAVAILABLE: 'The provider is not available right now',
              GENERIC: 'Provider products could not be discovered',
            },
          },
          ACTIONS: {
            ADD_PRODUCT: 'Add product',
            SAVE: 'Save',
            CANCEL: 'Cancel',
            ACCEPT: 'Accept',
            EDIT: 'Edit',
            DELETE: 'Delete',
          },
          FORM: {
            DISPLAY_NAME: 'Custom name',
            VISIBLE: 'Visible',
          },
          EMPTY: {
            PRODUCTS: 'This provider has no mapped products yet',
            RIDE_PRODUCTS: 'There are no WAIIS products configured',
          },
          TABLE: {
            PRODUCT_KEY: 'Provider product',
            RIDE_PRODUCT: 'WAIIS product',
            VISIBLE: 'Visible',
            ACTIONS: 'Actions',
          },
          MODAL: {
            NEW_PRODUCT: 'New product',
            EDIT_PRODUCT: 'Edit product',
            PRODUCT_KEY: 'Provider product',
            PRODUCT_KEY_HELP: 'Exact product name at the provider (e.g. UberX, Standard)',
            RIDE_PRODUCT: 'WAIIS product',
            RIDE_PRODUCT_PLACEHOLDER: 'Select a WAIIS product',
            VISIBLE: 'Visible',
          },
          VALIDATION: {
            PRODUCT_KEY_REQUIRED: 'Provider product is required',
            RIDE_PRODUCT_REQUIRED: 'WAIIS product is required',
          },
          CONFIRM: {
            DELETE_PRODUCT_TITLE: 'Delete product?',
            DELETE_PRODUCT_TEXT: '"{{product}}" will be permanently deleted',
          },
          ERROR: {
            TITLE: 'Error',
          },
          SUCCESS: {
            PROVIDER_SAVED: 'Provider saved',
          },
        },
      },
      MATCH_REVIEW: {
        DRIVER: '驾驶员',
        PASSENGER: '乘客',
        VERIFY: '验证',
        SELECT_DRIVER: '选择一个驾驶员',
        SELECT_PASSENGER: '选择一个乘客',
        DRIVER_DATA: '驾驶员数据',
        PASSENGER_DATA: '乘客数据',
        ROUTE_MAP: '路线图',
        NO_DATA: '没有可用数据',
        ENTER_ROUTINE_IDS: '输入驾驶员和乘客的例行ID以在地图上查看路线',
        LOADED: '已加载',
        USER: '用户',
        DISTANCE: '距离',
        DURATION: '持续时间',
        PRICE: '价格',
        LOADING: '加载中',
        SHOW_HEXAGONS: '显示六边形',
        SHOW_MAP_HEXAGONS: '显示地图上所有六边形',
        SHOW_POLYLINE: '显示路线',
        ADD_DRIVER: '添加司机',
        ADD_RIDER: '添加乘客',
        SELECT_ROUTINE: '点击此处添加路线',
        NAME: '姓名',
        LOCATIONS: '位置',
        ERROR_LOADING_ROUTE: '加载路线时出错',
        SELECT_ROUTE_DETAILS: '选择路线以查看详情',
        COPY_PHP_PAYLOAD: '复制 PHP 负载',
        COPIED: '已复制',
        CENTER: '居中',
        H3_RESOLUTION: 'H3分辨率',
        HEXAGON_POINTS: '六边形点',
        SIGNIFICANT_POINTS: '重点',
        ALL_POINTS: '所有点',
        ERROR: '错误',
        MAPS_LOAD_ERROR: '加载Google地图失败',
        ENTER_DRIVER_ID: '请输入驾驶员例行ID',
        ENTER_PASSENGER_ID: '请输入乘客例行ID',
        ERROR_VERIFYING: '验证{{type}}例程时出错',
        PICKUP: '接送{{type}}',
        ORIGIN: '起点{{type}}',
        DROPOFF: '下车{{type}}',
        DESTINATION: '目的地{{type}}',
        DRIVER_TEXT: '驾驶员',
        PASSENGER_TEXT: '乘客',
        COORDINATES: '{{lat}}, {{lng}}',
        H3_INDEX: 'H3索引（Res {{res}}）',
        LOADING_ROUTINE: '加载例程...',
        UNKNOWN_ERROR: '未知错误',
        SEARCH_RADIUS: '搜索半径',
        RADIUS_PLACEHOLDER: '半径(米)',
        FOUND: '发现',
        INTEREST_POINTS: '兴趣点',
        NO_POINTS_FOUND: '在指定半径内未找到关注点',
        ERROR_FETCHING_POINTS: '获取关注点时出错',
        SEARCH_INTEREST_POINTS: '搜索感兴趣的地点',
        CANCEL_SEARCH: '取消搜索',
        LOAD_FROM_FILE: '从文件加载',
        PROCESS_COMPLETE: '流程已完成',
        CONFIRM: '确认',
      },
    },
  },
};
